export default "__VITE_ASSET__ba878a72__"